import { Box, ListItemText } from '@mui/material'

import { useSweepstakesOptions } from '../options'
import DarkSkeleton from './DarkSkeleton'
import useSweepstakesDetailsListItemEntriesText from './useSweepstakesDetailsListItemEntriesText'
import useSweepstakesDetailsListItemPrimaryText from './useSweepstakesDetailsListItemPrimaryText'

const SweepstakesDetailsListItemText = () => {
  const options = useSweepstakesOptions()
  const loading = options == null
  const primary = useSweepstakesDetailsListItemPrimaryText()
  const entries = useSweepstakesDetailsListItemEntriesText()

  return loading ? (
    <ListItemText
      primary={
        <Box mb={1}>
          <DarkSkeleton variant="rectangular" width={110} height={18} />
        </Box>
      }
      secondary={<DarkSkeleton variant="rectangular" width={90} height={14} />}
    />
  ) : (
    <ListItemText primary={primary} secondary={entries} />
  )
}

export default SweepstakesDetailsListItemText
